/* ==========================================================================
   stock-preorder.js  -  Előrendelhető / Külső Raktárból felirat-híd
   --------------------------------------------------------------------------
   A Kalles gyári, tömörített JS (theme.min.js / interactable.min.js) rendeli
   ki a jelvényt, egyetlen, globális felirattal (T4SProductStrings.badgepreOrder
   = "Külső Raktárból"), és kizárólag a Shopify készletállapot alapján dönti el,
   hogy megjelenik-e. Azt a fájlt nem módosítjuk.

   Ez a híd ezért csak annyit tesz, hogy a MÁR KIRENDELT jelvény feliratát
   átírja azoknál a termékeknél, amelyek a `preorder` terméktaget viselik
   (ezt a Liquid a data-stock-class="preorder" attribútummal jelzi a jelvény
   konténerén). A színt a stock-preorder.css intézi.

   Következmények:
   - Megjelölés nélküli terméken a szkript SEMMIT nem csinál, tehát amíg egyetlen
     termék sem kapja meg a `preorder` taget, a viselkedés bájtra a
     korábbi marad.
   - A tag önmagában nem tud jelvényt megjeleníteni: csak egy olyan jelvény
     feliratát írja át, amelyet a készletlogika már láthatóvá tett.
   ========================================================================== */
(function () {
  'use strict';

  var SCOPE = '[data-stock-class="preorder"]';
  var BADGE = SCOPE + ' > .t4s-badge-preorder';

  function label() {
    var strings = window.T4SProductStrings;
    var text = strings && strings.badgeStockPreorder;
    return typeof text === 'string' ? text : '';
  }

  function sweep() {
    var text = label();
    if (!text) return;

    var badges = document.querySelectorAll(BADGE);
    for (var i = 0; i < badges.length; i++) {
      // A vizsgálat egyben a végtelen ciklus elleni védelem is: a saját
      // írásunk kiváltotta mutációnál a felirat már egyezik, tehát megállunk.
      if (badges[i].textContent !== text) badges[i].textContent = text;
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      sweep();
    });
  }

  function start() {
    sweep();

    if (!window.MutationObserver || !document.body) return;

    // A gyári JS a konténer innerHTML-jét cseréli (variánsváltás, AJAX-szal
    // betöltött kártyák, ajánlott termékek, quick view stb.), ez childList
    // mutáció, tehát ezzel minden újrarenderelt jelvényt elkapunk.
    //
    // Az attribútum-figyelés csak biztonsági tartalék: éles úton a Liquid már a
    // szerver-HTML-be beírja a data-stock-class értéket, tehát a jelvény mindig
    // KÉSŐBB renderelődik, mint ahogy az attribútum megjelenik. Ha viszont
    // valami utólag állítja be az attribútumot egy MÁR kirendelt jelvényen,
    // childList mutáció nélkül is le kell futnunk. Saját kódunk sosem írja ezt
    // az attribútumot, így körkörös meghívás nem alakulhat ki.
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-stock-class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
